import {
  getFirestore,
  onSnapshot,
  doc,
  setDoc,
  updateDoc,
  collection,
  serverTimestamp,
  where,
  query,
  orderBy,
  deleteDoc,
  getDocs,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { TYPES } from "./branch.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// -------------------------- Snapshot --------------------------
const branchSub = [];
export const snapBranchs = (callback) => (dispatch) => {
  getBranchsSuccess(dispatch, []);
  const cRef = collection(firestore, REF.BRANCH);
  const uid = auth?.currentUser?.uid;
  const c1 = where("owner", "==", uid);
  const c2 = orderBy("createAt", "desc");
  const qRef = query(cRef, c1, c2);
  // snapshot
  const unSub = onSnapshot(qRef, (snapshot) => {
    if (snapshot?.docs?.length > 0) {
      const data = snapshot.docs.map((doc) => doc.data());
      getBranchsSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  branchSub.push(unSub);
};

export const unSnapBranchs = () => (dispatch) => {
  branchSub.forEach((subscriber) => {
    subscriber();
  });
  branchSub.length = 0;
};

// -------------------------- snap Access Shop --------------------------
const staffbranchSub = [];
export const snapStaffBranchs = (callback) => (dispatch) => {
  const cRef = collection(firestore, REF.BRANCH);
  const uid = auth?.currentUser?.uid;
  const c1 = where("coop", "array-contains", uid);
  // const c2 = orderBy("createAt", "desc");
  const qRef = query(cRef, c1);
  // snapshot
  const unSub = onSnapshot(qRef, (snapshot) => {
    if (snapshot?.docs?.length > 0) {
      const data = snapshot.docs.map((doc) => doc.data());
      console.log("data-be", data);
      getStaffBranchSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  staffbranchSub.push(unSub);
};

export const unSnapStaffBranchs = () => (dispatch) => {
  staffbranchSub.forEach((subscriber) => {
    subscriber();
  });
  staffbranchSub.length = 0;
};

// -------------------------- Add Branch --------------------------

export const addBranch =
  ({ branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.BRANCH);
    const uid = auth?.currentUser?.uid;
    const id = doc(cRef).id;
    const dRef = doc(cRef, id);
    const data = {
      ...branch,
      id,
      owner: uid,
      createAt: serverTimestamp(),
    };
    const shopId = branch.shopId;
    checkShopID(shopId).then((response) => {
      if (response.status === 200) {
        setDoc(dRef, data, { merge: true })
          .then(() => {
            if (callback) {
              callback({
                status: 200,
                data: id,
              });
            }
          })
          .catch((error) => {
            if (callback) {
              callback({
                status: 500,
                data: error.message,
              });
            }
          });
      } else {
        if (callback) {
          callback(response);
        }
      }
    });
  };

// -------------------------- Update Branch --------------------------

export const updateBranch =
  ({ branch, update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.BRANCH);
    const id = branch.id;
    const dRef = doc(cRef, id);
    const data = {
      ...update,
      updateAt: serverTimestamp(),
    };
    const shopId = branch.shopId;
    const updateId = update.shopId;
    if (shopId !== updateId) {
      checkShopID(updateId).then((response) => {
        if (response.status === 200) {
          updateDoc(dRef, data)
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((error) => {
              if (callback) {
                callback({
                  status: 500,
                  data: error.message,
                });
              }
            });
        } else {
          if (callback) {
            callback(response);
          }
        }
      });
    } else {
      updateDoc(dRef, data)
        .then(() => {
          if (callback) {
            callback({
              status: 200,
            });
          }
        })
        .catch((error) => {
          if (callback) {
            callback({
              status: 500,
              data: error.message,
            });
          }
        });
    }
  };

// -------------------------- Delete Branch --------------------------
export const deleteBranch =
  ({ data }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.BRANCH);
    const id = data.id;
    const dRef = doc(cRef, id);
    deleteDoc(dRef)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      });
  };

// -------------------------- Snapshot Detail --------------------------

const detailSub = [];
export const snapDetail =
  ({ id }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.BRANCH);
    const dRef = doc(cRef, id);
    // snapshot
    const unSub = onSnapshot(dRef, (doc) => {
      if (doc) {
        const data = doc.data();
        getDetailSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    detailSub.push(unSub);
  };

export const unSnapDetail = () => (dispatch) => {
  detailSub.forEach((subscriber) => {
    subscriber();
  });
  detailSub.length = 0;
};

// -------------------------- Check --------------------------

const checkShopID = (shopId) => {
  const cRef = collection(firestore, REF.BRANCH);
  const c1 = where("shopId", "==", shopId);
  const qRef = query(cRef, c1);
  return getDocs(qRef)
    .then((snapshot) => {
      if (snapshot.docs.length === 0) {
        return {
          status: 200,
        };
      } else {
        return {
          status: 500,
          data: "Duplicate Shop ID",
        };
      }
    })
    .catch((error) => {
      return {
        status: 500,
        data: error,
      };
    });
};

// ----------------- Get Branches By Owner Id --------------

const branchOwnSub = [];
export const snapBranchesByOwnerId = (callback) => (dispatch) => {
  const cRef = collection(firestore, REF.BRANCH);
  // const c1 = where("owner", "==", ownerId);
  // const dRef = query(cRef, c1);
  // snapshot
  const unSub = onSnapshot(cRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      getBranchesOwnerSuccess(dispatch, data);
      if (callback) {
        callback(data);
      }
    }
  });
  branchOwnSub.push(unSub);
};

export const unSnapBranchesByOwner = () => (dispatch) => {
  branchOwnSub.forEach((subscriber) => {
    subscriber();
  });
  branchOwnSub.length = 0;
};

// ----------------- update access for shop --------------
export const updateAccessShop =
  ({ branchId, coop }, callback) =>
  (dispatch) => {
    console.log({ branchId, coop });
    const cRef = collection(firestore, REF.BRANCH);
    const dRef = doc(cRef, branchId);
    const update = {
      coop,
    };
    updateDoc(dRef, update)
      .then(() => {
        if (callback) {
          callback({ status: 200 });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            data: error,
            status: 500,
          });
        }
      });
  };

// -------------------------- Dispatch --------------------------
const getBranchsSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_ALL_BRANCHS_SUCCESS,
    payload: data,
  });
};

const getStaffBranchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_STAFF_BRANCHS_SUCCESS,
    payload: data,
  });
};

const getDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_DETAIL_SUCCESS,
    payload: data,
  });
};

const getBranchesOwnerSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_BRANCHS_OWNER_SUCCESS,
    payload: data,
  });
};

// ------------ get branch by id ----------- //
export const getBranchByShopId =
  ({ shopId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.BRANCH);
    const c0 = where("shopId", "==", shopId);
    const qRef = query(cRef, c0);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const [data] = snapshot.docs.map((doc) => doc.data());
        getDetailBranchSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
  };

const getDetailBranchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_DETAIL_BRANCH_SUCCESS,
    payload: data,
  });
};
